import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';

import AccountBalancePanel from "../student/widgets/AccountBalancePanel";
import PanelInfo from "./PanelInfo";


let AccountInfoWidget = ({ ...props }) => {
    let account = props.store.accounts.getById(props.accountId);

    account = account.include(["employer", "supervisor", "student"]);

    let startDate = moment(account.startDate).format("MMMM D Y");
    let endDate = moment(account.endDate).format("MMMM D Y");

    let createdDate = account.createdDate
        ? moment(account.createdDate).format("MMMM D Y, h:mm a")
        : "N/A";
    //Format the student name
    const studentName = account.student.name;
    //Get/format the supervisor names
    const supervisorName = account.supervisor.name;
    const secondarySupervisorNames = account.getSecondarySupervisorNames();

    const employerName = account.employer.name;

    return (
        <div role="list" title="Account Info">
            <PanelInfo role="listitem" flexDirection="column">
                <div className="top">
                    <span>Employment Dates</span>
                </div>
                <div className="bottom">
                    <span aria-label="Account start date" className="panelInfoMedium">{startDate} -</span>
                </div>
                <div className="bottom">
                    <span aria-label="Account end date" className="panelInfoMedium">{endDate}</span>
                </div>
            </PanelInfo>
            <PanelInfo role="listitem" flexDirection="column">
                <div className="top">
                    <span>Primary Supervisor</span>
                </div>
                <div className="bottom">
                    <span className="panelInfoLarge">{supervisorName}</span>
                </div>
            </PanelInfo>
            <PanelInfo role="listitem" flexDirection="column">
                <div className="top">
                    <span>Pay Rate</span>
                </div>
                <div className="bottom">
                    <span className="panelInfoLarge">${account.payRate.toFixed(2)}</span>
                    <span>/hr</span>
                </div>
            </PanelInfo>
            <PanelInfo role="listitem" flexDirection="column">
                <div className="top">
                    <span>Account Created</span>
                </div>
                <div className="bottom">
                    <span className="panelInfoMedium">{createdDate}</span>
                </div>
            </PanelInfo>
            <AccountBalancePanel
                studentId={account.studentId}
                store={props.store}
            />
        </div>
    );
}

AccountInfoWidget = observer(AccountInfoWidget)

export default AccountInfoWidget;

